// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* make sure to keep these in sync with other constants,
e.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */

/* layout contants from \`layout-constants.js\` */

/* overridden by src/lib/themes/guiHelpers.js */

.filter_filter_QIEkf {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-grow: 1;

  background: var(--ui-white);
  border-radius: 10rem;
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
  height: 2.5rem;

  position: relative;
}

.filter_filter-icon_Su864 {
  position: absolute;
  top: 0;

  height: 1rem;
  width: 1rem;
}

[dir='ltr'] .filter_filter-icon_Su864 {
  left: 0;
  margin: 0.75rem 0.75rem 0.75rem 1rem;
}

[dir='rtl'] .filter_filter-icon_Su864 {
  right: 0;
  margin: 0.75rem 1rem 0.75rem 0.75rem;
  transform: scaleX(-1);
}

.filter_filter_QIEkf:focus-within {
  box-shadow: 0 0 0 0.25rem var(--looks-transparent);
}

/*
    Hidden state
*/

.filter_x-icon-wrapper_HCvmb {
  opacity: 0;
  position: absolute;
  top: 0;

  display: flex;
  justify-content: center;
  align-items: center;

  overflow: hidden; /* Mask the icon animation */
  height: 1.25rem;
  width: 1.25rem;
  margin: 0.625rem;

  border-radius: 50%;
  pointer-events: none;
  cursor: default;
  transition: opacity 0.05s linear;
}

[dir='ltr'] .filter_x-icon-wrapper_HCvmb {
  right: 0;
}

[dir='rtl'] .filter_x-icon-wrapper_HCvmb {
  left: 0;
}

/*
    Shown state
*/

.filter_filter_QIEkf.filter_is-active_tVxPg .filter_x-icon-wrapper_HCvmb {
  pointer-events: auto;
  cursor: pointer;
  opacity: 1;
  transition: opacity 0.05s linear;
}

.filter_filter_QIEkf.filter_is-active_tVxPg .filter_x-icon-wrapper_HCvmb:hover {
  transform: scale(1.2, 1.2);
}

/*
    Hidden state
*/

.filter_x-icon_zeN25 {
  position: relative;
  margin: 0.25rem;
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
  transform: translateX(0.5rem);
  transition: transform 0.085s cubic-bezier(0.78, 1, 1, 1);
}

/*
    Shown state
*/

.filter_filter_QIEkf.filter_is-active_tVxPg .filter_x-icon-wrapper_HCvmb .filter_x-icon_zeN25 {
  transform: translateX(0);
}

.filter_filter-input_Zkydy {
  flex-grow: 1;
  height: 2.5rem;
  background-color: transparent;
  -webkit-appearance: none;
  outline: none;
  border: 0;
  color: var(--text-primary);
  font-size: 0.75rem;
  letter-spacing: 0.15px;
  cursor: text;
}

[dir='ltr'] .filter_filter-input_Zkydy {
  padding: 0.625rem 2rem 0.625rem 3rem;
}

[dir='rtl'] .filter_filter-input_Zkydy {
  padding: 0.625rem 3rem 0.625rem 2rem;
}

.filter_filter-input_Zkydy::-ms-input-placeholder {
  opacity: 0.5;
  color: var(--text-primary);
  font-size: 0.875rem;
  letter-spacing: 0.15px;
}

.filter_filter-input_Zkydy::placeholder {
  opacity: 0.5;
  color: var(--text-primary);
  font-size: 0.875rem;
  letter-spacing: 0.15px;
}

[dir='ltr'] .filter_filter-input_Zkydy::-ms-input-placeholder {
  padding: 0 0 0 0.25rem;
}

[dir='ltr'] .filter_filter-input_Zkydy::placeholder {
  padding: 0 0 0 0.25rem;
}

[dir='rtl'] .filter_filter-input_Zkydy::-ms-input-placeholder {
  padding: 0 0.25rem 0 0;
}

[dir='rtl'] .filter_filter-input_Zkydy::placeholder {
  padding: 0 0.25rem 0 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/filter/filter.css"],"names":[],"mappings":"AAAA;sDACsD;;AAEtD,+CAA+C;;AAE/C,+CAA+C;;AAE/C;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;;EAEZ,2BAA2B;EAC3B,oBAAoB;EACpB,yBAAyB;KACtB,sBAAsB;MACrB,qBAAqB;UACjB,iBAAiB;EACzB,cAAc;;EAEd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;;EAEN,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,OAAO;EACP,oCAAoC;AACtC;;AAEA;EACE,QAAQ;EACR,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,kDAAkD;AACpD;;AAEA;;CAEC;;AAED;EACE,UAAU;EACV,kBAAkB;EAClB,MAAM;;EAEN,aAAa;EACb,uBAAuB;EACvB,mBAAmB;;EAEnB,gBAAgB,EAAE,4BAA4B;EAC9C,eAAe;EACf,cAAc;EACd,gBAAgB;;EAEhB,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,OAAO;AACT;;AAEA;;CAEC;;AAED;EACE,oBAAoB;EACpB,eAAe;EACf,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;CAEC;;AAED;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;KACtB,sBAAsB;MACrB,qBAAqB;UACjB,iBAAiB;EACzB,6BAA6B;EAC7B,wDAAwD;AAC1D;;AAEA;;CAEC;;AAED;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,6BAA6B;EAC7B,wBAAwB;EACxB,aAAa;EACb,SAAS;EACT,0BAA0B;EAC1B,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,0BAA0B;EAC1B,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,0BAA0B;EAC1B,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":["/* make sure to keep these in sync with other constants,\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\n\n/* layout contants from `layout-constants.js` */\n\n/* overridden by src/lib/themes/guiHelpers.js */\n\n.filter {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  flex-grow: 1;\n\n  background: var(--ui-white);\n  border-radius: 10rem;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  height: 2.5rem;\n\n  position: relative;\n}\n\n.filter-icon {\n  position: absolute;\n  top: 0;\n\n  height: 1rem;\n  width: 1rem;\n}\n\n[dir='ltr'] .filter-icon {\n  left: 0;\n  margin: 0.75rem 0.75rem 0.75rem 1rem;\n}\n\n[dir='rtl'] .filter-icon {\n  right: 0;\n  margin: 0.75rem 1rem 0.75rem 0.75rem;\n  transform: scaleX(-1);\n}\n\n.filter:focus-within {\n  box-shadow: 0 0 0 0.25rem var(--looks-transparent);\n}\n\n/*\n    Hidden state\n*/\n\n.x-icon-wrapper {\n  opacity: 0;\n  position: absolute;\n  top: 0;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  overflow: hidden; /* Mask the icon animation */\n  height: 1.25rem;\n  width: 1.25rem;\n  margin: 0.625rem;\n\n  border-radius: 50%;\n  pointer-events: none;\n  cursor: default;\n  transition: opacity 0.05s linear;\n}\n\n[dir='ltr'] .x-icon-wrapper {\n  right: 0;\n}\n\n[dir='rtl'] .x-icon-wrapper {\n  left: 0;\n}\n\n/*\n    Shown state\n*/\n\n.filter.is-active .x-icon-wrapper {\n  pointer-events: auto;\n  cursor: pointer;\n  opacity: 1;\n  transition: opacity 0.05s linear;\n}\n\n.filter.is-active .x-icon-wrapper:hover {\n  transform: scale(1.2, 1.2);\n}\n\n/*\n    Hidden state\n*/\n\n.x-icon {\n  position: relative;\n  margin: 0.25rem;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  transform: translateX(0.5rem);\n  transition: transform 0.085s cubic-bezier(0.78, 1, 1, 1);\n}\n\n/*\n    Shown state\n*/\n\n.filter.is-active .x-icon-wrapper .x-icon {\n  transform: translateX(0);\n}\n\n.filter-input {\n  flex-grow: 1;\n  height: 2.5rem;\n  background-color: transparent;\n  -webkit-appearance: none;\n  outline: none;\n  border: 0;\n  color: var(--text-primary);\n  font-size: 0.75rem;\n  letter-spacing: 0.15px;\n  cursor: text;\n}\n\n[dir='ltr'] .filter-input {\n  padding: 0.625rem 2rem 0.625rem 3rem;\n}\n\n[dir='rtl'] .filter-input {\n  padding: 0.625rem 3rem 0.625rem 2rem;\n}\n\n.filter-input::-ms-input-placeholder {\n  opacity: 0.5;\n  color: var(--text-primary);\n  font-size: 0.875rem;\n  letter-spacing: 0.15px;\n}\n\n.filter-input::placeholder {\n  opacity: 0.5;\n  color: var(--text-primary);\n  font-size: 0.875rem;\n  letter-spacing: 0.15px;\n}\n\n[dir='ltr'] .filter-input::-ms-input-placeholder {\n  padding: 0 0 0 0.25rem;\n}\n\n[dir='ltr'] .filter-input::placeholder {\n  padding: 0 0 0 0.25rem;\n}\n\n[dir='rtl'] .filter-input::-ms-input-placeholder {\n  padding: 0 0.25rem 0 0;\n}\n\n[dir='rtl'] .filter-input::placeholder {\n  padding: 0 0.25rem 0 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"filter": `filter_filter_QIEkf`,
	"filter-icon": `filter_filter-icon_Su864`,
	"filterIcon": `filter_filter-icon_Su864`,
	"x-icon-wrapper": `filter_x-icon-wrapper_HCvmb`,
	"xIconWrapper": `filter_x-icon-wrapper_HCvmb`,
	"is-active": `filter_is-active_tVxPg`,
	"isActive": `filter_is-active_tVxPg`,
	"x-icon": `filter_x-icon_zeN25`,
	"xIcon": `filter_x-icon_zeN25`,
	"filter-input": `filter_filter-input_Zkydy`,
	"filterInput": `filter_filter-input_Zkydy`
};
export default ___CSS_LOADER_EXPORT___;
